import { List, ListItem, Navbar, Page } from "framework7-react";

import { FeelingChip } from "@/components/FeelingChip";
import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { FeelingEnum } from "@/generated/graphql/graphql";
import { usePageReady } from "@/hooks/usePageReady";
import { useUserFeelings } from "@/hooks/useUserFeelings";

export const FeelingListPage = createPage("FeelingListPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { isPageReady, getPageProps } = usePageReady(pageName);
  const userFeelings = useUserFeelings({ skip: !isPageReady });

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>気分の設定</NavTitle>
        <NavRightEmpty />
      </Navbar>

      <List
        dividersIos
        inset
        mediaList
        strong
      >
        {userFeelings.map((f) => (
          <ListItem
            key={f.id}
            chevronCenter
            link={`/settings/app/feelings/${f.feelingKey}/`}
          >
            <div slot="content-start">
              {/* FeelingChip には enum を渡す前提のため、型のみFeelingEnumへキャストして整合 */}
              <FeelingChip feelingKey={f.feelingKey as unknown as FeelingEnum} />
            </div>
          </ListItem>
        ))}
      </List>
    </Page>
  );
}
